import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initialState = {
  watchFilter: {},
  watchResults: null,
  watchResultsCount: 0,
  selectedWatch: null,
  selectedList: [],
  lastResultsPosition: 0,
  resultsList: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.WATCHES_FILTER_SAVE:
      return filterSave(state, action);
    case constants.WATCHES_SAVE:
      return watchesSave(state, action);
    case constants.WATCHES_SAVE_SELECTED:
      return watchesSaveSelected(state, action);
    case constants.WATCHES_SET_LAST_POSITION:
      return watchesSetLastPosition(state, action);
    case constants.WATCHES_TOGGLE_LIST:
      return watchesToggleList(state, action);
	  default:
	    return state;
  }
}

function filterSave(state, action) {
  const newFilters = Object.assign({}, state, {
    watchFilter: action.filters,
  });
  return newFilters;
}

function watchesSave(state, action) {
  return Object.assign({}, state, {
    watchResults: action.watches,
    watchResultsCount: action.count,
  });
}

function watchesSaveSelected(state, action) {
  return Object.assign({}, state, {
    selectedList: action.watches,
  });
}

function watchesSetLastPosition(state, action) {
  return Object.assign({}, state, {
    lastResultsPosition: action.scrollPos,
  });
}

function watchesToggleList(state, action) {
  return Object.assign({}, state, {
    resultsList: !state.resultsList,
  });
}

